import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_ADD_CARATULA } from '../../../config/forms'
import { toast } from 'react-toastify'
import CamposCaratula from './CamposCaratula'
import moment from 'moment'

const selector = formValueSelector(FORM_ADD_CARATULA)

class DialogoComunicacionAdd extends Component {
  constructor (props) {
    super(props)
    this.changeArribo = this.changeArribo.bind(this)
    this.changeZarpada = this.changeZarpada.bind(this)
    this.changeBuque = this.changeBuque.bind(this)
    this.handleAgregarExportador = this.handleAgregarExportador.bind(this)
    this.handleSacarExportador = this.handleSacarExportador.bind(this)
    this.handleBuqueAceitero = this.handleBuqueAceitero.bind(this)
  }

  async componentDidMount () {
    const { change: formChange } = this.props
    console.log('giros')
    this.props.getGiros()
    this.props.getBuques()
    formChange('fechaArribo', moment().format('YYYY-MM-DD[T]HH:mm'))
    formChange('fechaZarpada', moment().format('YYYY-MM-DD[T]HH:mm'))
  }

  changeArribo (e) {
    const { change: formChange } = this.props
    formChange('fechaArribo', e.target.value)
  }

  changeZarpada (e) {
    const { change: formChange } = this.props
    formChange('fechaZarpada', e.target.value)
  }

  changeBuque (value) {
    console.log('buque', value)
    const { change: formChange } = this.props
    if (value.imo === null) toast.info(`El buque seleccionado ${value.nombre} no tiene un # de IMO válido`)
    formChange('buque', value)
  }

  handleAgregarExportador () {
    const {
      actualizarExportador
    } = this.props
    actualizarExportador('ADD')
  }

  handleSacarExportador (exportador) {
    const {
      sacarExportador
    } = this.props
    sacarExportador(exportador)
  }

  handleBuqueAceitero () {
    const {  
      changeBuqueAceitero 
    } = this.props
    changeBuqueAceitero()
  }

  render () {
    const {
      handleClose,
      handleSubmit,
      giros,
      buques,
      buque,
      isRequesting,
      selectedGiro,
      caratulaExportador,
      buqueAceitero,
      updateListaExportadoresSeleccionados
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Nueva Carátula</Card.Text>
          </Card.Header>
          <Card.Body>
            <div>
              <CamposCaratula
                giros={giros}
                buques={buques}
                buque={buque}
                onSelect={this.onSelect}
                selectedGiro={selectedGiro}
                isRequesting={isRequesting}
                changeBuque={this.changeBuque}
                changeArribo={this.changeArribo}
                changeZarpada={this.changeZarpada}
                handleAgregarExportador={this.handleAgregarExportador}
                handleSacarExportador={this.handleSacarExportador}
                caratulaExportador={caratulaExportador}
                buqueAceitero={buqueAceitero}
                handleBuqueAceitero={this.handleBuqueAceitero}
                updateListaExportadoresSeleccionados={updateListaExportadoresSeleccionados} />
            </div>
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button>
            <Button style={{ margin: '2%' }} onClick={handleSubmit} >Guardar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaCaratula: state.comunicacionEmbarque.consultaCaratula,
    giros: state.comunicacionEmbarque.giros,
    buques: state.comunicacionEmbarque.buques,
    selectedGiro: state.comunicacionEmbarque.selectedGiro,
    isRequesting: state.comunicacionEmbarque.requestingGiros,
    fechaArribo: selector(state, 'fechaArribo'),
    fechaZarpada: selector(state, 'fechaZarpada'),
    buque: selector(state, 'buque'),
    buqueAceitero: state.comunicacionEmbarque.buqueAceitero,
    caratulaExportador: state.comunicacionEmbarque.caratulaExportador,
    exportadoresSeleccionados: state.comunicacionEmbarque.exportadoresSeleccionados
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ADD_CARATULA,
  enableReinitialize: false,
  keepDirtyOnReinitialize: false,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoComunicacionAdd))
